import script from "./ReceitasReceber.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasReceber.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasReceber.vue?vue&type=style&index=0&id=11aed47e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11aed47e"]])

export default __exports__